"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendErrorMessage = exports.sendMessage = exports.displaySuccessMessage = exports.displayErrorMessage = void 0;

var _messagestatus = require("../state/actions/messagestatus");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */


var displayErrorMessage = function displayErrorMessage(text) {
  return (0, _messagestatus.displayMessage)({
    name: 'urgent',
    type: 'notification',
    variant: 'attention',
    time: 5000,
    align: 'top-left',
    icon: 'bullhorn',
    title: 'Urgent',
    message: text,
    close: false,
    handleClose: null
  });
};

exports.displayErrorMessage = displayErrorMessage;

var displaySuccessMessage = function displaySuccessMessage(text) {
  return (0, _messagestatus.displayMessage)({
    name: 'success',
    type: 'notification',
    variant: 'secondary',
    time: 5000,
    align: 'top-left',
    icon: 'check-circle',
    title: 'Success',
    message: text,
    close: false,
    handleClose: null
  });
};

exports.displaySuccessMessage = displaySuccessMessage;

var sendMessage = function sendMessage(text) {
  return (0, _messagestatus.displayMessage)({
    name: 'standard',
    type: 'toaster',
    variant: 'primary',
    time: 5000,
    align: 'bottom-left',
    icon: null,
    title: null,
    message: text,
    close: true,
    handleClose: null
  });
};

exports.sendMessage = sendMessage;

var sendErrorMessage = function sendErrorMessage(text) {
  return (0, _messagestatus.displayMessage)({
    name: 'attention',
    type: 'toaster',
    variant: 'attention',
    time: 5000,
    align: 'bottom-left',
    icon: null,
    title: null,
    message: text,
    close: true,
    handleClose: null
  });
};

exports.sendErrorMessage = sendErrorMessage;